module.exports = __webpack_public_path__ + "static/media/noun-faq.5a814385.svg";